
import AppColorPicker from "@/components/ColorPicker.vue";
import { GoogleCalendarService } from "@/services/google-calendar-service";
import Vue from "vue";
export default Vue.extend({
	data() {
		return {
			name: "",
			color: "#FF0000",
			pending: false
		};
	},
	props: {
		value: Object as () => gapi.client.calendar.CalendarListEntry
	},
	computed: {
		nameIsEmpty():boolean {
			return /^\s*$/.test(this.name);
		},
		title():string {
			if (this.value && this.value.id) {
				return this.$ct("edit-calendar").toString();
			}
			return this.$ct("create-calendar").toString();
		},
		saveLabelKey():string {
			return this.value != null ? "common.save" : "common.create";
		}
	},
	watch: {
		"value": {
			handler() {
				if (this.value) {
					this.name = this.value.summary;
					this.color = this.value.backgroundColor || "#FF0000";
				} else {
					this.name = "";
					this.color = "#FF0000";
				}
			},
			immediate: true,
		}
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		async save() {
			this.pending = true;
			try{
				if (!this.value.id) {
					var calendar = await GoogleCalendarService.createCalendar(this.name, this.color);
				} else {
					var calendar = await GoogleCalendarService.updateCalendar(this.value.id, this.name, this.color);
				}
				this.$emit("input", calendar);
				this.$emit("close");
			}catch(err){
				throw err;
			}finally{
				this.pending = false;
			}
		}
	},
	components: {
		AppColorPicker
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
